/* Hero: pulls the section up under the header when it is first on the page, and handles the video. */
if ( ! customElements.get('hero-section') ) {
	class HeroSection extends HTMLElement {
		connectedCallback(){
			this.section = this.closest('.shopify-section');
			this.main = document.getElementById('main');
			this.header = document.querySelector('.mount-header .header-holder') || document.querySelector('.header-holder');
			this.video = this.querySelector('[data-hero-video]');

			this.place();
			window.addEventListener('resize', () => this.place(), { passive: true });
			document.addEventListener('shopify:section:reorder', () => this.place());

			if ( this.video ) {
				if ( window.matchMedia('(prefers-reduced-motion: reduce)').matches ) {
					this.video.pause();
					if ( this.video.poster ) this.querySelector('.hero__media').style.backgroundImage = `url(${this.video.poster})`;
				} else {
					// some browsers block autoplay until the element is in view
					new IntersectionObserver(entries => {
						entries.forEach(e => e.isIntersecting ? this.video.play().catch(() => {}) : this.video.pause());
					}).observe(this.video);
				}
			}
		}
		place(){
			const first = this.section && this.main && this.section === this.main.firstElementChild;
			this.classList.toggle('hero--first', !! first);
			if ( first && this.dataset.behindHeader === 'true' && this.header ) {
				const h = this.header.offsetHeight;
				this.style.setProperty('--hero-header-offset', `${h}px`);
				this.style.setProperty('--hero-pull', `calc(-1 * var(--body-margin) - ${h}px)`);
			} else {
				this.style.removeProperty('--hero-header-offset');
				this.style.removeProperty('--hero-pull');
			}
		}
	}
	customElements.define('hero-section', HeroSection);
}
